import { ChangeEventHandler } from 'react';
import { useNavigate } from 'react-router';
import cn from 'classnames';

import { RouteTo } from '../../routes';

import styles from './TagsHeader.module.scss';

type TagsHeaderProps = {
    tagsCount: number;
    searchString: string;
    onSearchStringChange: ChangeEventHandler<HTMLInputElement>;
    isSelectionMode: boolean;
    selectedCount: number;
    onToggleSelectionMode: () => void;
    onCopyMultiple: () => void;
};

export function TagsHeader(props: TagsHeaderProps) {
    const {
        tagsCount,
        searchString,
        onSearchStringChange,
        isSelectionMode,
        selectedCount,
        onToggleSelectionMode,
        onCopyMultiple,
    } = props;
    const navigate = useNavigate();

    const selectLabel = selectedCount > 0 ? 'Deselect all' : 'Select';

    return (
        <div className={styles.header}>
            <div className={styles.buttons}>
                <h1>Tags ({tagsCount})</h1>
                <button
                    className={styles.button}
                    onClick={() => navigate(RouteTo.TagNew())}
                >
                    Add new
                </button>
                <button
                    className={cn(styles.button, isSelectionMode && 'primary')}
                    onClick={onToggleSelectionMode}
                >
                    {selectLabel}
                </button>
                {selectedCount > 0 && (
                    <button
                        className={cn(styles.button, 'primary')}
                        onClick={onCopyMultiple}
                    >
                        Copy To Multiple ({selectedCount})
                    </button>
                )}
            </div>
            <div className={styles.searchWrapper}>
                <input
                    aria-label="search tags"
                    autoFocus
                    className="editInput"
                    type="text"
                    value={searchString}
                    placeholder="Search..."
                    onChange={onSearchStringChange}
                />
            </div>
        </div>
    );
}
